import { Box, Snackbar as MuiSnackbar, SnackbarProps, Typography } from '@mui/material';
import { FC, Fragment } from 'react';
import { CloseButton } from './closeButton';
import { IconArea } from './iconArea';

type Props = {
  text: string;
  infoText?: string;
  onCloseIconClick?: () => void;
  icon?: JSX.Element;
  color?: string;
} & Omit<SnackbarProps, 'sx'>;

export const Snackbar: FC<Props> = ({
  text,
  infoText,
  onCloseIconClick,
  icon,
  anchorOrigin,
  color = 'background.paper',
  ...snackbarProps
}) => {
  const renderText = (text: string) => {
    const result = text.split('\n').map((line, index) => (
      <Fragment key={index}>
        {line}
        <br />
      </Fragment>
    ));
    return result;
  };

  return (
    <MuiSnackbar
      {...snackbarProps}
      sx={{ maxWidth: '400px', minWidth: '300px' }}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'center'
        }
      }
    >
      <Box
        sx={{
          display: 'flex',
          backgroundColor: color,
          alignItems: 'center',
          borderRadius: '12px',
          padding: '10px 14px',
          minWidth: '275px',
          justifyContent: 'space-between',
          boxShadow: '2px 2px 4px #596B847A'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '12px'
          }}
        >
          {icon && <IconArea icon={icon} />}
          <Box>
            <Typography variant="body1">{renderText(text)}</Typography>
            {infoText && <Typography variant="body2">{renderText(infoText)}</Typography>}
          </Box>
        </Box>
        {onCloseIconClick && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <CloseButton onCloseIconClick={onCloseIconClick} />
          </Box>
        )}
      </Box>
    </MuiSnackbar>
  );
};
